import {
    Box,
    Button,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    Text,
    InputGroup,
    InputRightElement,
    Image,
    useToast,
    Circle
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { ReactComponent as AddPhoto } from "../../svg/camera.svg";
import { ReactComponent as Eye } from "../../svg/eye.svg";
import { ReactComponent as EyeSlash } from "../../svg/eyeSlash.svg";
import { useDispatch, useSelector } from "react-redux";
import { selectedMenu, resetEdit } from "../../redux/actions/actions";
import { useHistory } from "react-router-dom";
import {
    loadSettings, submitChangePassword, updateProfile
} from "../../redux/api_calls/apiCalls";

export default function Settings() {
    const [isMyProfileActive, setIsMyProfileActive] = useState(true);
    const [courseImage, setCourseImage] = useState(null);
    const [courseImageUrl, setCourseImageUrl] = useState(null)
    const [firstNameValue, setFirstNameValue] = useState("");
    const [lastNameValue, setLastNameValue] = useState("");
    const [emailIdValue, setEmailIdValue] = useState("");
    const [phoneNumberValue, setPhoneNumberValue] = useState("");
    const [currentPasswordValue, setCurrentPasswordValue] = useState("");
    const [newPasswordValue, setNewPasswordValue] = useState("");
    const [newConfirmPasswordValue, setNewConfirmPasswordValue] = useState("");
    const [courseImageError, setCourseImageError] = useState(null);
    const [firstNameError, setFirstNameError] = useState(null);
    const [lastNameError, setLastNameError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [phoneNumberError, setPhoneNumberError] = useState(null);
    const [currentPasswordError, setCurrentPasswordError] = useState(null);
    const [newPasswordError, setNewPasswordError] = useState(null);
    const [newConfirmPasswordError, setNewConfirmPasswordError] = useState(null);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { settingsData } = useSelector(state => state.settingsState)
    const formStatus = useSelector(state => state.formStatus)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch();
    const history = useHistory();
    const toast = useToast();

    function validatePhoto() {
        if (!courseImage) {
            setCourseImageError("Please select a Cover Photo for the Course!");
            return true;
        } else {
            setCourseImageError(null);
            return false;
        }
    }

    function validateFirstName() {
        let firstName = document.getElementById('first_name').value;
        if (!firstName.length) {
            setFirstNameError("First Name is required")
            return true
        } else if (!/^[a-zA-Z]+$/.test(firstName)) {
            setFirstNameError("First Name shouldn't contain any number or special character")
            return true
        }
        else {
            setFirstNameError(null);
            setFirstNameValue(firstName);
            return false
        }
    }
    function validateLastName() {
        let lastName = document.getElementById('last_name').value;
        if (!lastName.length) {
            setLastNameError("Last Name is required")
            return true
        } else if (!/^[a-zA-Z]+$/.test(lastName)) {
            setLastNameError("Last Name shouldn't contain any number or special character")
            return true
        }
        else {
            setLastNameError(null);
            setLastNameValue(lastName);
            return false
        }
    }

    function validateEmailId() {
        let emailId = document.getElementById('email_id').value;
        if (!emailId.length) {
            setEmailError("Email ID is required")
            return true
        } else if (!/\S+@\S+\.\S+/.test(emailId)) {
            setEmailError("Email Id is not valid")
            return true
        }
        else {
            setEmailError(null);
            setEmailIdValue(emailId);
            return false
        }
    }

    function validatePhoneNumber() {
        let phoneNumber = document.getElementById('phone_number').value;
        if (!phoneNumber.length) {
            setPhoneNumberError("Phone Number is required")
            return true
        } else if (!/^[0-9]+$/.test(phoneNumber)) {
            setPhoneNumberError("Phone Number shouldn't contain any alphabet or special character")
            return true
        } else if (phoneNumber.length !== 10) {
            setPhoneNumberError("Phone Number should be 10 digits")
            return true
        }
        else {
            setPhoneNumberError(null);
            setPhoneNumberValue(phoneNumber);
            return false
        }
    }

    function validateCurrentPassword() {
        let currentPassword = document.getElementById('current_password').value;
        if (!currentPassword.length) {
            setCurrentPasswordError("Current Password is required")
            return true
        }
        else {
            setCurrentPasswordError(null);
            setCurrentPasswordValue(currentPassword);
            return false
        }
    }

    function validateNewPassword() {
        let newPassword = document.getElementById('new_password').value;
        if (!newPassword.length) {
            setNewPasswordError("New Password is required")
            return true
        }
        else {
            setNewPasswordError(null);
            setNewPasswordValue(newPassword);
            return false
        }
    }

    function validateNewConfirmPassword() {
        let newConfirmPassword = document.getElementById('confirm_password').value;
        if (!newConfirmPassword.length) {
            setNewConfirmPasswordError("New Confirm Password is required")
            return true
        } else if (newConfirmPassword !== document.getElementById('new_password').value) {
            setNewConfirmPasswordError("New Password and Confirmation Password are not same")
            return true
        }
        else {
            setNewConfirmPasswordError(null);
            setNewConfirmPasswordValue(newConfirmPassword);
            return false
        }
    }

    const validateProfileFields = () => {
        return validatePhoto() || validateFirstName() || validateLastName() || validateEmailId() || validatePhoneNumber();
    }

    const validatePasswordFields = () => {
        return validateCurrentPassword() || validateNewPassword() || validateNewConfirmPassword();
    }

    const myProfileSwitchkHandler = () => {
        setIsMyProfileActive(true);
    };

    const changePasswordSwitchHandler = () => {
        setIsMyProfileActive(false);
    };

    const loadLocal_image = (courseImage) => {
        if (courseImage) {
            if (typeof courseImage === "object") {
                let extension = courseImage.name.substring(
                    courseImage.name.lastIndexOf(".") + 1
                );
                let acceptedExtensions = ["jpeg", "jpg", "png"];
                if (!acceptedExtensions.includes(extension.toLowerCase())) {
                    setCourseImageError("Invalid file type");
                    setCourseImageUrl(null)
                    setCourseImage(null);
                }
                else {
                    setCourseImageUrl(URL.createObjectURL(courseImage))
                    toast({
                        title: "Image Uploaded",
                        description: "Image Uploaded",
                        status: "success",
                        duration: 1000,
                        isClosable: true,
                    })
                }
            }
        }
    };

    const showOnload_image = (image) => {
        setCourseImage(image);
        setCourseImageUrl(image);
    };

    const saveChangesHandler = () => {
        if (validateProfileFields()) {
            return
        } else {
            let formData = new FormData()

            formData.append("id", phoneNumberValue)
            formData.append("email", emailIdValue)
            formData.append("first_name", firstNameValue)
            formData.append("last_name", lastNameValue)
            formData.append("mobile_no", phoneNumberValue)
            formData.append("profile_image", courseImage)
            formData.append("token", "")

            dispatch(updateProfile(formData));
        }
    };

    const changePasswordHandler = () => {
        if (validatePasswordFields()) {
            return
        } else {
            let formData = {
                email: emailIdValue,
                current_password: document.getElementById('current_password').value,
                password: document.getElementById('new_password').value,
                password_confirmation: document.getElementById('confirm_password').value
            }
            dispatch(submitChangePassword(formData));
        }
    };

    const resetForm = () => {
        // setCourseImage(null);
        // setCourseImageUrl(null)
        setCurrentPasswordValue("");
        setNewPasswordValue("");
        setNewConfirmPasswordValue("");
    }

    const cancelHandler = () => {
        dispatch(resetEdit());
        history.push("/dashboard");
    };

    const handleCurrentPasswordClick = () => setShowCurrentPassword(!showCurrentPassword);

    const handleNewPasswordClick = () => setShowNewPassword(!showNewPassword);

    const handleConfirmPasswordClick = () => setShowConfirmPassword(!showConfirmPassword);

    useEffect(() => {
        dispatch(selectedMenu(7))
        let formData = {
            email: "admin1@gmail.com",
            token: "WpMrIjpkL9pUZTXG4Jh3I9VTMO7Lsc5r"
        }
        console.log(formData)
        dispatch(loadSettings(formData));
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setFirstNameValue(settingsData.first_name);
            setLastNameValue(settingsData.last_name);
            setEmailIdValue(settingsData.email);
            setPhoneNumberValue(settingsData.mobile_no);
            // setCourseImage("https://pixy.org/src/19/193722.jpg");
            showOnload_image(settingsData.profile);
        }, 0);
        console.log("settingsData", settingsData);
    }, [settingsData]);

    useEffect(() => {
        if (formStatus.success) {
            toast({
                title: "Password Changed Successfully!",
                description: "Password Changed",
                status: "success",
                duration: 3000,
                isClosable: true,
            })
            resetForm()
        }
        else if (formStatus.error) {
            toast({
                title: "Something went wrong!",
                description: "Error!",
                status: "error",
                duration: 3000,
                isClosable: true,
            })
        }
        // eslint-disable-next-line
    }, [formStatus.success, formStatus.error]);

    useEffect(() => {
        if (formStatus.updateSuccess) {
            toast({
                title: "Update Profile Successfully!",
                description: "Update Profile",
                status: "success",
                duration: 3000,
                isClosable: true,
            })
            resetForm()
        }
        else if (formStatus.updateError) {
            toast({
                title: "Something went wrong!",
                description: "Error!",
                status: "error",
                duration: 3000,
                isClosable: true,
            })
        }
        // eslint-disable-next-line
    }, [formStatus.updateSuccess, formStatus.updateError]);

    useEffect(() => {
        if (isMyProfileActive) {
            document.getElementById("change_password").style.backgroundColor =
                "transparent";
            document.getElementById("change_password").style.color = "#999999";
            document.getElementById("my_profile").style.backgroundColor = "white";
            document.getElementById("my_profile").style.color = "black";
            document.getElementById("my_profile").style.boxShadow = "0px 3px 10px rgba(0, 0, 0, 0.15)";
            document.getElementById("change_password").style.boxShadow = "";
        } else {
            document.getElementById("my_profile").style.backgroundColor =
                "transparent";
            document.getElementById("my_profile").style.color = "#999999";
            document.getElementById("change_password").style.backgroundColor =
                "white";
            document.getElementById("change_password").style.color = "black";
            document.getElementById("change_password").style.boxShadow = "0px 3px 10px rgba(0, 0, 0, 0.15)";
            document.getElementById("my_profile").style.boxShadow = "";
        }
    }, [isMyProfileActive]);

    useEffect(() => { }, [courseImageError]);

    return (
        <Box
            flexGrow="1"
            d="flex"
            justifyContent="flex-start"
            alignItems="center"
            flexDirection="column"
            minH="90vh"
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box
                width={["95%", "95%", "90%", "85%"]}
                justifyContent={["center", "center", "flex-start", "flex-start"]}
                alignItems={["center", "center", "flex-start", "flex-start"]}
                d="flex"
                mb="2rem"
                flexDirection="column"
            >
                <Text
                    fontSize={["20px", "25px", "30px", "40px"]}
                    d={["none", "none", "none", "flex"]}
                    fontWeight="900"
                    style={{ fontFamily: "Mulish, sans-serif" }}
                    mb="2rem"
                >
                    Settings
                </Text>
                <Box
                    width={["100%", "100%", "90%", "85%"]}
                    d="flex"
                    flexDir={["column", "column", "row", "row"]}
                    justifyContent={["center", "center", "flex-start", "flex-start"]}
                    mt="1.5rem"
                    mb="1.5rem"
                >
                    <Button
                        borderRadius="lg"
                        p={["6px 15px", "8px 20px", "12px 30px"]}
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="700"
                        fontSize={["13px", "14px", "16px"]}
                        mr={["0", "0", "20px", "20px"]}
                        mb={["20px", "20px", "0", "0"]}
                        id="my_profile"
                        onClick={myProfileSwitchkHandler}
                    >
                        My Profile
                    </Button>
                    <Button
                        borderRadius="lg"
                        p={["6px 15px", "8px 20px", "12px 30px"]}
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="700"
                        fontSize={["13px", "14px", "16px"]}
                        id="change_password"
                        onClick={changePasswordSwitchHandler}
                    >
                        Change Password
                    </Button>
                </Box>
                {isMyProfileActive ? (<>
                    <Box
                        width={["100%", "100%", "100%", "85%"]}
                        justifyContent={["center", "center", "flex-start", "flex-start"]}
                        alignItems={["center", "center", "flex-start", "flex-start"]}
                        mb="1rem"
                        d="flex"
                    >
                        <Box
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "1.5rem",
                                width: "90%",
                            }}
                        >
                            <FormControl isInvalid={courseImageError}>
                                <FormLabel
                                    variant="custom"
                                    htmlFor="add_photo"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Profile Photo
                                </FormLabel>

                                <Box width="150px" id="add_photo" mr='5rem' position='relative'>
                                    <label htmlFor="add_photo_helper">
                                        <Button
                                            as="span"
                                            width="150px"
                                            height="150px"
                                            bg="white"
                                            bgImage={courseImageUrl ? courseImageUrl : null}
                                            bgRepeat='no-repeat'
                                            bgSize='cover'
                                            bgPosition='center'
                                            borderRadius="50%"
                                            fontWeight="800"
                                            fontSize={["12px", "14px", "16px", "18px"]}
                                            style={{ fontFamily: "Mulish, sans-serif" }}
                                            color="#E4B716"
                                            _hover={{ bg: "white", bgImage: courseImageUrl ? courseImageUrl : null, bgRepeat: 'no-repeat', bgSize: 'cover', bgPosition: 'center' }}
                                            d="flex"
                                            flexDir="column"
                                            border="1px solid rgba(0, 0, 0, 0.1)"
                                            cursor="pointer"
                                        >
                                            {
                                                !courseImageUrl &&
                                                <>
                                                    <Image src='/blank.png' id="output_image" borderRadius='50%' width="150px" height="150px" position="absolute" />
                                                </>
                                            }
                                        </Button>
                                        {
                                            courseImageUrl &&
                                            <Circle
                                                size='30px'
                                                bg='white'
                                                position='absolute'
                                                right='5px'
                                                bottom='10px'
                                                boxShadow='xl'
                                                border="1px solid rgba(0, 0, 0, 0.1)"
                                                cursor='pointer'
                                                fill='#E4B716'
                                            >
                                                <AddPhoto width='15px' height='15px' />
                                            </Circle>
                                        }
                                    </label>
                                    <input
                                        accept="image/png, image/jpeg, image/jpg"
                                        id="add_photo_helper"
                                        name="add_photo_helper"
                                        type="file"
                                        onChange={(e) => {
                                            loadLocal_image(e.target.files[0]);
                                            setCourseImage(e.target.files[0]);
                                            setCourseImageError(null);
                                        }}
                                        style={{ display: "none" }}
                                    />
                                </Box>
                                <FormErrorMessage fontSize="sm">
                                    {courseImageError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        justifyContent="space-between"
                        mb="1rem"
                    >
                        <Box width="45%">
                            <FormControl isInvalid={firstNameError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    First Name
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="first_name"
                                    width="100%"
                                    borderRadius="lg"
                                    bgColor="white"
                                    value={firstNameValue}
                                    onChange={(e) => {
                                        setFirstNameError(null);
                                        setFirstNameValue(e.target.value);
                                    }}
                                    fontSize={["9px", "11px", "13px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {firstNameError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="45%">
                            <FormControl isInvalid={lastNameError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Last Name
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="last_name"
                                    width="100%"
                                    borderRadius="lg"
                                    bgColor="white"
                                    fontSize={["9px", "11px", "13px", "16px"]}
                                    value={lastNameValue}
                                    onChange={(e) => {
                                        setLastNameError(null)
                                        setLastNameValue(e.target.value);
                                    }}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {lastNameError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        justifyContent="space-between"
                    >
                        <Box width="45%">
                            <FormControl isInvalid={emailError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Email
                                </FormLabel>
                                <Input
                                    type="email"
                                    color="#666666"
                                    id="email_id"
                                    width="100%"
                                    borderRadius="lg"
                                    bgColor="white"
                                    isReadOnly
                                    value={emailIdValue}
                                    onChange={(e) => {
                                        setEmailError(null)
                                        setEmailIdValue(e.target.value);
                                    }}
                                    fontSize={["9px", "11px", "13px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">{emailError}</FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="45%">
                            <FormControl isInvalid={phoneNumberError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Phone
                                </FormLabel>
                                <Input
                                    type="tel"
                                    color="#666666"
                                    id="phone_number"
                                    width="100%"
                                    borderRadius="lg"
                                    bgColor="white"
                                    fontSize={["9px", "11px", "13px", "16px"]}
                                    value={phoneNumberValue}
                                    onChange={(e) => {
                                        setPhoneNumberError(null)
                                        setPhoneNumberValue(e.target.value);
                                    }}
                                />
                                <FormErrorMessage fontSize="sm">{phoneNumberError}</FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        flexDir={["column", "column", "row", "row"]}
                        justifyContent={["center", "center", "flex-start", "flex-start"]}
                        mt="2rem"
                    >
                        <Button
                            bgColor="#A0A4D9"
                            color="white"
                            borderRadius="lg"
                            p={["6px 15px", "8px 20px", "12px 30px"]}
                            _hover={{ bg: "#9093c2" }}
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="800"
                            fontSize={["13px", "14px", "16px"]}
                            mr={["0", "0", "20px", "20px"]}
                            mb={["20px", "20px", "0", "0"]}
                            onClick={saveChangesHandler}
                        >
                            Save Changes
                        </Button>
                        <Button
                            bgColor="white"
                            color="#999999"
                            borderRadius="lg"
                            border="1px solid rgba(0, 0, 0, 0.2)"
                            p={["6px 15px", "8px 20px", "12px 30px"]}
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="800"
                            fontSize={["13px", "14px", "16px"]}
                            onClick={cancelHandler}
                        >
                            Cancel
                        </Button>
                    </Box>
                </>) : <>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        justifyContent="space-between"
                        mb="1rem"
                    >
                        <Box width={window.outerWidth > 768 ? "45%" : "100%"}>
                            <FormControl isInvalid={currentPasswordError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Current Password
                                </FormLabel>
                                <InputGroup size="md">
                                    <Input
                                        pr="4.5rem"
                                        type={showCurrentPassword ? "text" : "password"}
                                        color="#666666"
                                        id="current_password"
                                        borderRadius="lg"
                                        bgColor="white"
                                        value={currentPasswordValue}
                                        onChange={(e) => {
                                            setCurrentPasswordError(null)
                                            setCurrentPasswordValue(e.target.value);
                                        }}
                                        fontSize={["9px", "11px", "13px", "16px"]}
                                    />
                                    <InputRightElement width="4.5rem">
                                        <Button style={{ backgroundColor: "transparent", padding: "0" }} size="sm" onClick={handleCurrentPasswordClick}>
                                            {showCurrentPassword ? (<EyeSlash style={{ width: "1.5rem", height: "1.2rem" }} />) : (<Eye style={{ width: "1.5rem", height: "1.2rem" }} />)}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                <FormErrorMessage fontSize="sm">
                                    {currentPasswordError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        justifyContent="space-between"
                        mb="1rem"
                    >
                        <Box width={window.outerWidth > 768 ? "45%" : "100%"}>
                            <FormControl isInvalid={newPasswordError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    New Password
                                </FormLabel>
                                <InputGroup size="md">
                                    <Input
                                        pr="4.5rem"
                                        type={showNewPassword ? "text" : "password"}
                                        color="#666666"
                                        id="new_password"
                                        borderRadius="lg"
                                        bgColor="white"
                                        value={newPasswordValue}
                                        onChange={(e) => {
                                            setNewPasswordError(null)
                                            setNewPasswordValue(e.target.value);
                                        }}
                                        fontSize={["9px", "11px", "13px", "16px"]}
                                    />
                                    <InputRightElement width="4.5rem">
                                        <Button style={{ backgroundColor: "transparent" }} size="sm" onClick={handleNewPasswordClick}>
                                            {showNewPassword ? (<EyeSlash style={{ width: "1.5rem", height: "1.2rem" }} />) : (<Eye style={{ width: "1.5rem", height: "1.2rem" }} />)}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                <FormErrorMessage fontSize="sm">
                                    {newPasswordError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        justifyContent="space-between"
                    >
                        <Box width={window.outerWidth > 768 ? "45%" : "100%"}>
                            <FormControl isInvalid={newConfirmPasswordError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Confirm Password
                                </FormLabel>
                                <InputGroup size="md">
                                    <Input
                                        pr="4.5rem"
                                        type={showConfirmPassword ? "text" : "password"}
                                        color="#666666"
                                        id="confirm_password"
                                        borderRadius="lg"
                                        bgColor="white"
                                        value={newConfirmPasswordValue}
                                        onChange={(e) => {
                                            setNewConfirmPasswordError(null)
                                            setNewConfirmPasswordValue(e.target.value);
                                        }}
                                        fontSize={["9px", "11px", "13px", "16px"]}
                                    />
                                    <InputRightElement width="4.5rem">
                                        <Button style={{ backgroundColor: "transparent" }} size="sm" onClick={handleConfirmPasswordClick}>
                                            {showConfirmPassword ? (<EyeSlash style={{ width: "1.5rem", height: "1.2rem" }} />) : (<Eye style={{ width: "1.5rem", height: "1.2rem" }} />)}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                <FormErrorMessage fontSize="sm">
                                    {newConfirmPasswordError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                    </Box>
                    <Box
                        width={["100%", "100%", "90%", "85%"]}
                        d="flex"
                        flexDir={["column", "column", "row", "row"]}
                        justifyContent={["center", "center", "flex-start", "flex-start"]}
                        mt="2rem"
                    >
                        <Button
                            bgColor="#A0A4D9"
                            color="white"
                            borderRadius="lg"
                            p={["6px 15px", "8px 20px", "12px 30px"]}
                            _hover={{ bg: "#9093c2" }}
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="800"
                            fontSize={["13px", "14px", "16px"]}
                            mr={["0", "0", "20px", "20px"]}
                            mb={["20px", "20px", "0", "0"]}
                            onClick={changePasswordHandler}
                        >
                            Change Password
                        </Button>
                        <Button
                            bgColor="white"
                            color="#999999"
                            borderRadius="lg"
                            border="1px solid rgba(0, 0, 0, 0.2)"
                            p={["6px 15px", "8px 20px", "12px 30px"]}
                            style={{ fontFamily: "Mulish, sans-serif" }}
                            fontWeight="800"
                            fontSize={["13px", "14px", "16px"]}
                            onClick={cancelHandler}
                        >
                            Cancel
                        </Button>
                    </Box>
                </>}
            </Box>
        </Box >
    );
}
